module.exports = __webpack_public_path__ + "static/img/airticket.d9482b1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/airticket.gif
// module id = qfyL
// module chunks = 0